import styled from 'styled-components';
import { Colors } from 'axl-reactjs-ui';

export const CheckboxContainer = styled.div`
    padding: 8px 15px;
    background-color: #cfcfcf80;
    border-radius: 3px;
`;

export const CheckboxInner = styled.div``;

export default {
    container: {},
    list: {
        position: 'absolute',
        top: '40px',
        left: '-10px',
        right: '-10px',
        bottom: 0,
        paddingLeft: '10px',
        paddingRight: '10px',
        overflowY: 'scroll'
    }
}
